// Typelizer digest a9822b897910bc2a3b4eea6314cf9a30
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /team/invitations/:invitation_id/delivery */
  create: (
    params: { invitationId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/team/invitations/:invitation_id/delivery', params, options),
    method: 'post',
  }),
}
